import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { MessageService, SelectItem } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { GenericService } from '../../../services/generic/generic.service';
import { siEsNull } from 'src/app/config/texto_comprobacion';
import { url } from 'src/app/config/config';
import { UploadService } from 'src/app/services/upload/upload.service';
import { FechasService } from 'src/app/services/fechas/fechas';
import { GenericDropdownComponent } from 'src/app/components/deplegable/generic-dropdown/generic-dropdown.component';

@Component({
  selector: 'app-packs-create',
  templateUrl: './packs-create.component.html',
  styleUrls: ['./packs-create.component.css']
})
export class PacksCreateComponent implements OnInit {

  @ViewChild('articulos1') articulos1: GenericDropdownComponent;

  public fileName:string = 'imagen.jpg';
  public numberPhoto:number = 1;
  public showCamera: boolean = false;   

  public packForm:UntypedFormGroup = new UntypedFormGroup({
    nombre: new UntypedFormControl('', Validators.required),
    eliminado: new UntypedFormControl('0'),
    archivo1: new UntypedFormControl(''),
    observaciones: new UntypedFormControl(''),
    idArticulo1: new UntypedFormControl(''),
    idArticulo2: new UntypedFormControl(''),
    idArticulo3: new UntypedFormControl(''),
    idArticulo4: new UntypedFormControl(''),
    idArticulo5: new UntypedFormControl(''),
    idArticulo6: new UntypedFormControl(''),
    idArticulo7: new UntypedFormControl(''),
    idArticulo8: new UntypedFormControl(''),
    idArticulo9: new UntypedFormControl(''),
    idArticulo10: new UntypedFormControl(''),
    idProveedor1: new UntypedFormControl(''),
    idProveedor2: new UntypedFormControl(''),
    idProveedor3: new UntypedFormControl(''),
    idProveedor4: new UntypedFormControl(''),
    idProveedor5: new UntypedFormControl(''),
    idProveedor6: new UntypedFormControl(''),
    idProveedor7: new UntypedFormControl(''),
    idProveedor8: new UntypedFormControl(''),
    idProveedor9: new UntypedFormControl(''),
    idProveedor10: new UntypedFormControl(''),
    cantidad1: new UntypedFormControl(''),
    cantidad2: new UntypedFormControl(''),
    cantidad3: new UntypedFormControl(''),
    cantidad4: new UntypedFormControl(''),
    cantidad5: new UntypedFormControl(''),
    cantidad6: new UntypedFormControl(''),
    cantidad7: new UntypedFormControl(''),
    cantidad8: new UntypedFormControl(''),
    cantidad9: new UntypedFormControl(''),
    cantidad10: new UntypedFormControl(''),
    fecha_creacion: new UntypedFormControl('')

  });

  public database = "sets";
  public update: boolean = false;
  public id = ""; 
  public noGrabar:boolean = false;   
  public file: File;  

  public imagePath;
  public message: string;
  public img: any ="https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com"; 
  public imgURL: any ="https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com"; 
  public url: string = url + "upload/sets/";      

  constructor(
    private location: Location,
    private messageService: MessageService,
    private genericService: GenericService,
    private _fechaService: FechasService,    
    private router: Router,
    private route: ActivatedRoute, 
    private _uploadService: UploadService         
  ) { }

    ngOnInit(): void {

      this.route.params.subscribe(data => {
        if (data.id == undefined) {
          this.iniciar(null);
        } else {
          this.id = data.id;
          this.update = true;
          this.genericService.getId(this.id, this.database).toPromise().then( (resp: any ) => {
            this.iniciar(resp[0]);
          }).catch(error => {
            console.log("error", error);
          });
        }
        //this.recuperaProveedores();
      });    
    };


    recuperaProveedores(){
      this.packForm.get('idProveedor1').valueChanges.subscribe(()=>{
        this.articulos1.reloadData();
      });      
    }

    iniciar( value ){

      let pack = value;
  
      if ( pack != null ) {
        for (const key in pack) {
          
          if( key.localeCompare('id') == 0) {
  
          } else {
           if (key.includes('fecha')) {
             this.packForm.get( key ).patchValue( this._fechaService.fechaUpdate(pack[key]));
           } else {
             this.packForm.get( key ).patchValue( siEsNull(pack[key]));
           }
          }
          
         };
        
         if (this.packForm.get('archivo1').value != null && this.packForm.get('archivo1').value.length > 0 ) {
          this.imgURL = this.url + this.packForm.get('archivo1').value;
          
        } else {
          this.imgURL = false;
        }
  
  
      }
    };
  
    regresar() {
      this.location.back();
    }   
    
    onSubmit() {

      this.noGrabar = true;
      let data = [{}];
      data[0]['id'] = this.id || '0';
  
      for (const key in this.packForm.value) {
  
        data[0][key] = this.packForm.value[key];
  
      }
  
      if (this.update) {
  
        this.genericService.update(data[0], this.database).toPromise().then((resp:any) => {
  
          if (this.file != null) {
            this.fileUpload(this.file, this.id,'archivo1');
          };

          this.messageService.add({ severity: 'success', summary: 'Registro', detail: 'Registro actualizado correctamente' });
  
  
          
          setTimeout(() => {
            this.router.navigate(['/dashboard/packs']);
          }, 2000);
  
        }).catch(error => {
          console.log("error packs", error);
  
        });
  
      } else {
  
  
        this.genericService.create(data[0], this.database).toPromise().then( (resp:any) => {
  
          data[0]['id'] = resp.id;
          this.id = resp.id;
          if (this.file != null) {
            this.fileUpload(this.file, this.id,'archivo1');
          };
          
  
          this.messageService.add({ severity: 'success', summary: 'Registro', detail: 'Registro creado correctamente' });
       
          setTimeout(() => {
            this.router.navigate(['/dashboard/packs']);
          }, 2000);
  
        }).catch(error => {
          console.log("Error Articulos, error");
  
        });
      }    
     
  
    }
    
    
    fileUpload(file: File, id: string, name:string) {
      this._uploadService.uploadFilesgeneric(file, id,'sets','sets',name).subscribe(
        res => {
          this.messageService.add({
            severity: "info",
            summary: "Registro imagen",
            detail: "Imagen Añadida Correctamente"
          });
          setTimeout(
            function() {
              // this.router.navigate(["dashboard/etiquetas"]);
              this.disableButton = false;
            }.bind(this),
            2000
          );
        },
        error => {
          console.error("Error", error);
        }
      );
    }    
  
    uploadFile(event,position:number) {
      if (position==1){ this.file = event.target.files[0];};
      let files = event.target.files;
  /*     let numb = this.file.name.lastIndexOf("."); */
      if (files.length === 0) return;
  
      var mimeType = files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.message = "Only images are supported.";
        return;
      }
  
      var reader = new FileReader();
      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = _event => {
       if (position==1) {this.imgURL = reader.result;};
      };
  
    };    


    getImage(event: { base64:string, file: File, numero: number }){

      if ( event.numero  == 1) {
        this.imgURL = event.base64;
        this.file = event.file;
      }

      this.showCamera = false;
    }
    
    openCamera(numero: number){
  
      this.fileName = 'imagen'+numero.toString()+'.jpg';
      this.numberPhoto = numero;
      this.showCamera = true;
    }

    deleteImagen(numero:number){
      if ( numero  == 1) {
        this.imgURL = this.img;
        this.file = null;
        this.packForm.get('archivo1').patchValue('');
      }
    }
  
    closeDialog(event){
      this.showCamera = false;  
    }    
    setProveedor(event,number){

      switch (number) {
        case 1:
          this.packForm.patchValue({
            idProveedor1: event});
          break;
        case 2:
          this.packForm.patchValue({
            idProveedor2: event});
          break;
        case 3:
          this.packForm.patchValue({
            idProveedor3: event});
          break;
        case 4:
          this.packForm.patchValue({
            idProveedor4: event});
          break;
        case 5:
          this.packForm.patchValue({
            idProveedor5: event});
          break;
        case 6:
          this.packForm.patchValue({
            idProveedor6: event});
          break;
        case 7:
          this.packForm.patchValue({
            idProveedor7: event});
          break;
        case 8:
          this.packForm.patchValue({
            idProveedor8: event});
          break;
        case 9:
          this.packForm.patchValue({
            idProveedor9: event});
          break;
        case 10:
          this.packForm.patchValue({
            idProveedor10: event});
          break;
      }
    }


    setArticulo(event,number){

      switch (number) {
        case 1:
          this.packForm.patchValue({
            idArticulo1: event});
          break;
        case 2:
          this.packForm.patchValue({
            idArticulo2: event});
          break;
        case 3:
          this.packForm.patchValue({
            idArticulo3: event});
          break;
        case 4:
          this.packForm.patchValue({
            idArticulo4: event});
          break;
        case 5:
          this.packForm.patchValue({
            idArticulo5: event});
          break;
        case 6:
          this.packForm.patchValue({
            idArticulo6: event});
          break;
        case 7:
          this.packForm.patchValue({
            idArticulo7: event});
          break;
        case 8:
          this.packForm.patchValue({
            idArticulo8: event});
          break;
        case 9:
          this.packForm.patchValue({
            idArticulo9: event});
          break;
        case 10:
          this.packForm.patchValue({
            idArticulo10: event});
          break;
      }
    }

}
